import { render, staticRenderFns } from "./SocialMediaIconsView.vue?vue&type=template&id=51c315ac&scoped=true&"
import script from "./SocialMediaIconsView.vue?vue&type=script&lang=js&"
export * from "./SocialMediaIconsView.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaIconsView.vue?vue&type=style&index=0&id=51c315ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c315ac",
  null
  
)

export default component.exports